import _ from '@lodash';

import AspectService from 'app/admin/aspect/service/AspectService';
import LabConnectionService from 'app/admin/labConnection/service/LabConnectionService';

const keySeparator = '[AND]';

class StorageLabMeasurementReaderService {
	constructor() {
		this.aspects = [];
		this.locations = {};
		this.samplingPointMap = {};
		this.analysisMap = {};
		this.analysisInfoMap = {};
	}

	getLocations(labConnectionId) {
		if (!labConnectionId) {
			return new Promise(resolve => resolve([]));
		}

		if (!this.locations[labConnectionId])
			return new Promise((resolve, reject) => {
				LabConnectionService.getLocations(labConnectionId).then(resp => {
					let values = [];

					for (let i = 0; i < resp.length; i += 1) {
						const option = { label: resp[i].parent_location + ' / ' + resp[i].identity_, value: resp[i].identity_ }
						let has = false;
						for (let j = 0; j < values.length; j += 1) if (values[j].value === option.value) has = true;
						if (!has) values.push(option);
					}

					this.locations[labConnectionId] = values;
					resolve(values);

				}).catch(e => reject(e));
			});
		return new Promise(resolve => {
			resolve(this.locations[labConnectionId]);
		});
	}

	getSamplingPoint(v, f) {
		const labConnectionId = v ? v.labConnection : null;
		const location = v ? v.location : null;
		const key = labConnectionId && location ? `${labConnectionId}${keySeparator}${location}` : null;

		return new Promise((resolve, reject) => {
			if (key && !this.samplingPointMap[key]) {
				LabConnectionService.getSamplingPointsByLocation(labConnectionId, location).then(resp => {
					let values = [];
					for (let i = 0; i < resp.length; i += 1) {
						const option = { label: resp[i], value: resp[i] }
						let has = false;
						for (let j = 0; j < values.length; j += 1) if (values[j].value === option.value) has = true;
						if (!has) values.push(option);
					}
					this.samplingPointMap[key] = values;
					resolve(values);
				}).catch(e => reject(e));
			} else if (key && this.samplingPointMap[key]) {
				resolve(this.samplingPointMap[key]);
			} else {
				resolve([]);
			}
		});
	}

	getAnalysisOptionList(v, f, m) {
		const index = parseInt(f.name.replace(/[^0-9]/g, ''), 10);
		const field = (v && v.fields && v.fields[index]) ? v.fields[index] : null;
		const labConnectionId = v ? v.labConnection : null;
		const value = field ? field.sampling_point : null;
		const key = labConnectionId && value ? `${labConnectionId}${keySeparator}${value}` : null;

		return new Promise((resolve, reject) => {
			if (key && !this.analysisMap[key])
				LabConnectionService.getAnalysisForSamplingPoint(labConnectionId, value).then(resp => {
					let values = [];
					for (let i = 0; i < resp.length; i += 1) {
						const option = { label: resp[i], value: resp[i] }
						let has = false;
						for (let j = 0; j < values.length; j += 1) if (values[j].value === option.value) has = true;
						if (!has) values.push(option);
					}
					this.analysisMap[key] = values;
					resolve(values);
				}).catch(e => reject(e));
			else if (key && this.analysisMap[key])
				resolve(this.analysisMap[key]);
			else
				resolve([]);
		});
	}

	getAnalysisInfo(v, f, m) {
		const index = parseInt(f.name.replace(/[^0-9]/g, ''), 10);
		const value = (v && v.fields && v.fields[index]) ? v.fields[index] : null;

		const labConnectionId = v ? v.labConnection : null;
		const sampling_point = value ? value.sampling_point : null;
		const analysis = value ? value.analysis : null;

		const getName = (id, sp, a) => { return id + keySeparator + sp + keySeparator + a; };
		const key = (labConnectionId && sampling_point && analysis) ? getName(labConnectionId, sampling_point, analysis) : null;

		return new Promise((resolve, reject) => {
			if (!key) return resolve([]);

			if (this.analysisInfoMap[key]) {
				return resolve(this.analysisInfoMap[key]);
			}

			LabConnectionService.getAnalysisInfo(labConnectionId, sampling_point, analysis).then(resp => {
				let values = [];
				const components = (resp && Array.isArray(resp.components)) ? resp.components : [];

				for (let i = 0; i < components.length; i += 1) {
					const option = { label: components[i], value: components[i] }
					let has = false;
					for (let j = 0; j < values.length; j += 1) if (values[j].value === option.value) has = true;
					if (!has) values.push(option);
				}

				this.analysisInfoMap[key] = values;
				resolve(values);
			}).catch(e => reject(e));
		});
	}

	getAspects(v, f, m) {
		return new Promise((resolve, reject) => {
			if (this.aspects.length === 0)
				AspectService.getListSelection().then(resp => {
					let values = [];
					for (let i = 0; i < resp.length; i += 1) {
						const option = { label: resp[i].name, value: resp[i].id + '' }
						let has = false;
						for (let j = 0; j < values.length; j += 1) if (values[j].value === option.value) has = true;
						if (!has) values.push(option);
					}
					this.aspects = values;
					resolve(values);
				}).catch(e => console.log(e));
			else if (this.aspects.length > 0)
				resolve(this.aspects);
			else
				resolve([]);
		});
	}
}

export default StorageLabMeasurementReaderService;
